'use client'

import React, { useState, useEffect } from 'react'

import dynamic from 'next/dynamic'

const History = dynamic(() => import('./history').then(mod => mod.History), { 
  ssr: false,
  loading: () => <div className="animate-pulse h-8 w-8 bg-gray-200 rounded-full" />
})

const HistoryList = dynamic(() => import('./history-list').then(mod => mod.HistoryList), { 
  ssr: false,
  loading: () => <div className="animate-pulse space-y-2">
    <div className="h-4 bg-gray-200 rounded w-3/4"></div>
    <div className="h-4 bg-gray-200 rounded w-1/2"></div>
  </div>
})

const MobileMenu = dynamic(() => import('./mobile-menu').then(mod => mod.MobileMenu), { 
  ssr: false,
  loading: () => <div className="animate-pulse h-8 w-8 bg-gray-200 rounded" />
})

type HistoryContainerProps = {
  location: 'sidebar' | 'header'
}

export default function HistoryContainer({ location }: HistoryContainerProps) {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return null
  }

  return (
    <div className={location === 'header' ? 'block sm:hidden' : 'hidden sm:block'}>
      {location === 'header' ? (
        <MobileMenu>
          <HistoryList userId="anonymous" />
        </MobileMenu>
      ) : (
        <History location={location}>
          <HistoryList userId="anonymous" />
        </History>
      )}
    </div>
  )
}